// 新近商家
import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper/core";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import "./index.less";

// api
import { GetNewRecommendConfig } from "api/home";
SwiperCore.use([Autoplay, Pagination, Navigation]);

const SwiperBanner = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    // 广告请求-首屏
    const getRecommendConfig = async () => {
      const res = await GetNewRecommendConfig({
        keys: "new_shop",
      });
      if (!res) return;
      if (res.ResponseStatus) return;
      const arr = res?.datas || [];

      arr.forEach((k) => {
        if (k.key === "new_shop") {
          setData(k?.template_common || []);
        }
      });
    };
    getRecommendConfig();
  }, []);

  const [swiper, setSwiper] = useState(2500);
  const onMouseEnter = () => {
    if (data?.length === 1) return;
    swiper.autoplay.stop();
  };
  const onMouseLeave = () => {
    if (data?.length === 1) return;
    swiper.autoplay.start();
  };

  return (
    <div
      className="new_home-new_shop"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="textC fz12 _666 mbottom8">新进商家</div>
      <Swiper
        slidesPerView={1}
        spaceBetween={1}
        loop
        loopAdditionalSlides={2}
        loopedSlides={3}
        pagination={true}
        navigation={true}
        autoplay
        className="mySwiper"
        onSwiper={setSwiper}
      >
        {data?.map?.((k, i) => (
          <SwiperSlide key={i}>
            <div
              className="pointer"
              onClick={() => {
                if (!k.template_url) return;
                window.open(k.template_url);
              }}
            >
              <img
                className="image"
                src={`${k.template_img}?x-oss-process=image/resize,m_lfit,h_600,w_600`}
                alt={k.template_name}
              />
              <div className="goods_info">
                <div className="store_name">{k.store_name}</div>
                <div className="goods_name owt" title={k.template_name}>
                  {k.template_name}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
export default SwiperBanner;
